import type * as Types from '../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetTariffPeriodEndQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetTariffPeriodEndQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly subscription: { readonly __typename?: 'YalperSubscription', readonly endDate?: string | null } } | null };


export const GetTariffPeriodEndDocument = gql`
    query GetTariffPeriodEnd {
  currentUser {
    subscription {
      endDate
    }
  }
}
    `;

/**
 * __useGetTariffPeriodEndQuery__
 *
 * To run a query within a React component, call `useGetTariffPeriodEndQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTariffPeriodEndQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTariffPeriodEndQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTariffPeriodEndQuery(baseOptions?: Apollo.QueryHookOptions<GetTariffPeriodEndQueryPage, GetTariffPeriodEndQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTariffPeriodEndQueryPage, GetTariffPeriodEndQueryVariables>(GetTariffPeriodEndDocument, options);
      }
export function useGetTariffPeriodEndLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTariffPeriodEndQueryPage, GetTariffPeriodEndQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTariffPeriodEndQueryPage, GetTariffPeriodEndQueryVariables>(GetTariffPeriodEndDocument, options);
        }
export function useGetTariffPeriodEndSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTariffPeriodEndQueryPage, GetTariffPeriodEndQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTariffPeriodEndQueryPage, GetTariffPeriodEndQueryVariables>(GetTariffPeriodEndDocument, options);
        }
export type GetTariffPeriodEndQueryHookResult = ReturnType<typeof useGetTariffPeriodEndQuery>;
export type GetTariffPeriodEndLazyQueryHookResult = ReturnType<typeof useGetTariffPeriodEndLazyQuery>;
export type GetTariffPeriodEndSuspenseQueryHookResult = ReturnType<typeof useGetTariffPeriodEndSuspenseQuery>;
export type GetTariffPeriodEndQueryResult = Apollo.QueryResult<GetTariffPeriodEndQueryPage, GetTariffPeriodEndQueryVariables>;